<template>
  <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :title="title" :size="'lg'" :centered="true" :btn_cancel="true"
    :btn_ok="true" :booTitile="true">
    <div class="modal-body">
      <CRow>
        <CCol sm="10" md="10" lg="5" xl="5" class="col-9 mb-1">
          <CInput label="Documento" placeholder="Digite documento" v-model="data_detail.document"
            @keypress="isNumber($event)" @keypress.enter="searchClient" maxlength="11" />
        </CCol>
        <CCol sm="2" md="2" lg="1" xl="1" class="my-auto mx-0 col-3">
          <CButton class="w-100 mt-2 d-flex justify-content-center align-items-center" color="info" v-c-tooltip.hover="{ content: `Buscar documento` }"
            @click="searchClient">
            <i class="fas fa-search"></i>
          </CButton>
        </CCol>
        <CCol sm="12" md="12" lg="6" xl="6">
          <CInput label="Nombre / Razon Social" placeholder="Nombre" v-model="data_detail.name" disabled />
        </CCol>
      </CRow>
      <CRow class="mt-1">
        <CCol sm="12" lg="6">
          <CInput label="Dirección" placeholder="Dirección" v-model="data_detail.address" />
        </CCol>

        <CCol sm="12" lg="6">
          <CInput label="Condición de Pago" placeholder="Condición de Pago" v-model="data_detail.payment_condition" />
        </CCol>
      </CRow>
      <CRow class="mt-1 d-flex align-items-center">
        <CCol sm="12" lg="9">
          <CTextarea label="Información Adicional" placeholder="Información Adicional"
            v-model="data_detail.additional_info" rows="1" />
        </CCol>
        <CCol sm="12" lg="3">
          <label class="mr-2 mb-0">{{ data_detail.igv ? 'Con IGV' : 'Sin IGV' }}</label>
          <CSwitchVue :key="componentKey" @changeSwitch="toggleIgv" class="mx-1 pl-2 pt-2" :checked="data_detail.igv"
            color="success" variant="opposite" shape="pill" v-bind="labelIcon" />
        </CCol>
      </CRow>

      <CRow class="mt-1">
        <CCol sm="12" lg="6" class="mb-3">
          <label for="adjustmentOption">Tipo de descuento</label>
          <select id="adjustmentOption" class="form-control" v-model="data_detail.discount_type"
            @change="updateAjustment">
            <option v-for="(item, index) in options" :key="index" :value="item.value">
              {{ item.label }}
            </option>
          </select>
        </CCol>
        <CCol sm="12" lg="6">
          <CInput label="Monto a Descontar" type="text" min="0" placeholder="0.00" @keypress="isNumber($event)"
            @blur="updateAjustment" v-model="data_detail.discount_amount" :disabled="data_detail.discount_type == 0" />
        </CCol>
      </CRow>
      <div class="row mt-2 d-flex justify-content-start" v-if="data_detail.discount_type == 0">
        <div class="col-12 col-lg-3">
          <div class="form-group text-left">
            <label for="totalVenta"><strong>COTIZACIÓN</strong></label>
            <input type="text" id="totalVenta" class="form-control text-center" :value="sale.total" readonly />
          </div>
        </div>
      </div>
      <div class="row mt-2 d-flex justify-content-start" v-else>
        <div class="col-12 col-lg-3">
          <div class="form-group text-left">
            <label for="totalVenta">TOTAL</label>
            <input type="text" id="totalVenta" class="form-control text-center" :value="sale.total" readonly />
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group text-left">
            <label for="totalVenta">AJUSTE</label>
            <input type="text" id="totalVenta" class="form-control text-center"
              :value="parseFloat(data_detail.adjustment).toFixed(2)" readonly />
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group text-left">
            <label for="totalVenta"><strong>COTIZACIÓN</strong></label>
            <input type="text" id="totalVenta" class="form-control text-center" :value="pagoTotal" readonly />
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <button @click="mtdClose" class="btn btn-danger">
        <i class="fa fa-times"></i>&nbsp;CERRAR
      </button>
      <button :disabled="cpButton" class="btn btn-info btn-info" @click="mtdSave">
        <i class="fas fa-dollar-sign"></i>GUARDAR
      </button>
      &nbsp;
    </template>
  </CModal>
</template>

<script>
import CModal from "../../../../shared/modals/cModalFormCom.vue";
import { mapActions } from "vuex";
import CSwitchVue from '@/components/shared/switch/CSwitch.vue';
export default {
  name: "c-quotes-modal",
  components: {
    CModal,
    CSwitchVue
  },
  data() {
    return {
      sale_new: {},
      data_detail: {
        document: '',
        name: '',
        payment_condition: '',
        additional_info: '',
        address: '',
        discount_type: 0,
        discount_amount: 0,
        adjustment: 0,
        igv: false,
        company_id: this.$store.getters.get_company.id,
      },
      quote: 0,
      options: [
        { label: "[Escoja una opción..]", value: 0 },
        { label: "Soles", value: 1 },
        { label: "%", value: 2 },
      ],
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      componentKey: 0,
    };
  },
  props: {
    title: String,
    sale: {
      type: Object,
      required: true,
    },
    boo_modal: Boolean,
  },
  watch: {
    boo_modal(newVal) {
      if (newVal) {
        this.sale_new = { ...this.sale };
        this.quote = this.sale.total || 0;
      }
    },
  },
  computed: {
    cpButton() {
      return !this.data_detail.document || !this.data_detail.name;
    },
    pagoTotal() {
      let tot = 0;
      tot = parseFloat(this.quote) + parseFloat(this.data_detail.adjustment);
      return parseFloat(tot).toFixed(2);
    },
  },
  created() {
  },
  methods: {
    ...mapActions(["get", "post"]),

    mtdClose() {
      this.mtdClear();
      this.$emit("mtdClose");
    },

    searchClient() {
      if (this.data_detail.document.length === 8 || this.data_detail.document.length === 11 || this.data_detail.document.length === 0) {
        if (this.data_detail.document.length === 0) {
          this.data_detail.document = '11111111'
        }
        this.get({
          url: this.$store.getters.get__url + "/quotes/searchClient/" + this.data_detail.company_id + "/" + this.data_detail.document,
          token: this.$store.getters.get__token,
        })
          .then((response) => {
            if (response.statusCode == 200) {
              if (response.data == null) {
                this.mtdSearchDocument();
              } else {
                this.data_detail.name = response.data.name;
                this.data_detail.address = response.data.address ?? "";
              }
            } else {
              this.data_detail.name = "";
              this.data_detail.address = "";
            }
          })
      } else {
        this.data_detail.name = "";
        this.data_detail.address = "";
        Swal.fire({
          title: "Documento no Valido",
          icon: "warning",
        });
      }
    },

    mtdSearchDocument: async function () {
      if (this.data_detail.document.length === 0) {
        this.data_detail.document = '11111111'
      }
      else if (this.data_detail.document.length === 8) {
        await this.get({
          url:
            this.$store.getters.get__url +
            "/Consultas/" +
            this.data_detail.document,
          token: this.$store.getters.get__token,
        }).then((response) => {
          if (response.data.boo === 3) {
            this.data_detail.document = "";
            this.data_detail.name = "";
            this.data_detail.address = "";
            this.sale_new.entity_address = "";
            Swal.fire({
              title: "Documento no encontrado",
              icon: "warning",
            });
          } else {
            this.data_detail.name = response.data.name + " " + response.data.last_name;
            this.data_detail.address = response.data.direccion ?? "";
            this.sale_new.entity_address = response.data.direccion ?? "";
          }
        });
      }
      else if (this.data_detail.document.length === 11) {
        await this.get({
          url:
            this.$store.getters.get__url +
            "/Consultas/" +
            this.data_detail.document,
          token: this.$store.getters.get__token,
        }).then((response) => {
          if (response.data.boo === 3) {
            this.data_detail.document = "";
            this.data_detail.name = "";
            this.data_detail.address = "";
            this.sale_new.entity_address = "";
            Swal.fire({
              title: "Documento no encontrado",
              icon: "warning",
            });
          } else {
            this.data_detail.name = response.data.razon_social;
            this.data_detail.address = response.data.direccion ?? "";
            this.sale_new.entity_address = response.data.direccion ?? "";
          }
        });
      }
      else {
        this.data_detail.name = "";
        this.data_detail.address = "";
        Swal.fire({
          title: "Documento no Valido",
          icon: "warning",
        });
      }
    },

    mtdSave() {
      Swal.fire({
        title: "Esta seguro de realizar la Cotización",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.$emit("save", this.data_detail, this.sale.total, this.pagoTotal);
        }
      });
    },

    mtdClear() {
      this.quote = 0,
        this.data_detail = {
          document: '',
          name: '',
          payment_condition: '',
          additional_info: '',
          address: '',
          discount_type: 0,
          discount_amount: 0,
          adjustment: 0,
          igv: false,
          company_id: this.$store.getters.get_company.id,
        }
    },

    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    //Descuento
    updateAjustment() {
      this.data_detail.adjustment = 0;
      let adjustmentAmount = parseFloat(this.data_detail.discount_amount) || 0;

      //Soles
      if (this.data_detail.discount_type == 1) {
        this.data_detail.adjustment = parseFloat(adjustmentAmount * -1).toFixed(2);
        //%
      } else if (this.data_detail.discount_type == 2) {
        const total = this.sale_new.total;
        let tempAdjustment = (total * adjustmentAmount) / 100;
        this.data_detail.adjustment = parseFloat(tempAdjustment * -1).toFixed(2);
        //Predeterminado
      } else {
        this.data_detail.discount_amount = 0;
        this.data_detail.adjustment = 0;
      }
    },

    //IGV
    toggleIgv() {
      this.data_detail.igv = !this.data_detail.igv;
    }
  },

};
</script>

<style scoped>
.bg-purple {
  background-color: #926cdc;
}

.bg-white {
  background-color: white;
}

.bg-gris {
  background-color: #dee2e6;
}

.color-white {
  color: white;
}

.color-black {
  color: black;
}

.font-bold {
  font-weight: bold;
}

.container-type {
  height: 40px;
}

.container-type:hover {
  background-color: #17a2b8;
  /* bg-info */
  cursor: pointer;
}

.text {
  margin: auto;
}
</style>
